import type { PurchaseRequestStatus } from './api';

export const PR_STATUS_META: Record<PurchaseRequestStatus, { label: string; className: string }> = {
  pending_approval: { label: 'Awaiting approval', className: 'bg-amber-100 text-amber-700' },
  approved: { label: 'Approved', className: 'bg-green-100 text-green-700' },
  rejected: { label: 'Rejected', className: 'bg-red-100 text-red-700' },
  cancelled: { label: 'Cancelled', className: 'bg-gray-200 text-gray-700' },
};
